import { customBaseUrl, httpGet, httpPost } from "../store/http";

/**
 * Mock data for internal reporting
 */
const MOCK_STATS = {
  totalTransactions: "₦0.00",
  accountBalances: "₦0.00",
  loanPortfolio: "₦0.00",
  revenue: "₦0.00"
};

const MOCK_REPORTS = [];
const MOCK_SCHEDULES = [];
const MOCK_AUDIT_LOGS = [];

// --- Service Functions ---

export const getInternalReportStats = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, data: MOCK_STATS });
    }, 500);
  });
};

export const getInternalReports = async (params) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, data: MOCK_REPORTS });
    }, 500);
  });
};

export const generateInternalReport = async (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, message: "Report generation request received" });
    }, 800);
  });
};

export const exportInternalReports = async (params) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, data: MOCK_REPORTS });
    }, 500);
  });
};

export const getInternalReportSchedules = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, data: MOCK_SCHEDULES });
    }, 500);
  });
};

export const approveInternalReport = async (reportId, action) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, message: `Report ${action} successful` });
    }, 500);
  });
};

export const getInternalReportingAuditLogs = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, data: MOCK_AUDIT_LOGS });
    }, 500);
  });
};

export const deleteInternalReportSchedule = async (id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, message: "Schedule deleted successfully" });
    }, 500);
  });
};

export const createInternalReportSchedule = async (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: true, message: "Schedule action processed" });
    }, 500);
  });
};
